import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import SettingsCard from '../../UI/SettingsCard/SettingsCard';
import { useLockedFeatures } from '../../../providers/LockedFeatures.provider';
import { useLockedFeatureDialogue } from '../../../providers/LockedFeatureDialogue.provider';
import { usePermissions } from '../../../providers/Permissions.provider';
import { useTranslation } from 'react-i18next';

const { Box, Title, SubTitle } = vp;
type FC = FunctionComponent;
const Integrations: FC = () => {
  const history = useHistory();
  const lockedFeatures = useLockedFeatures();
  const { updateIsLocked } = useLockedFeatureDialogue();
  const { permissions } = usePermissions();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations' });
  return (
    <div>
      <Box mb="md" jc="sb">
        <Title title={t('pageTitle')} />
      </Box>
      <Box flx="col">
        <SubTitle subTitle={t('pageSubTitle')} />
        <Box mt="sm">
          <div>
            <SettingsCard
              Image="flinks"
              Title={t('flinksConfigurationTitle')}
              isLocked={!lockedFeatures.CustomFlinksCredentialsSet}
              onClickDetails={() => {
                !lockedFeatures.CustomFlinksCredentialsSet
                  ? updateIsLocked(true, 'Flinks')
                  : history.push('/integrations/Flinks');
              }}
            />
            <SettingsCard
              Image="plaid"
              Title={t('plaidConfigurationTitle')}
              isLocked={!lockedFeatures.CustomPlaidCredentialsSet}
              onClickDetails={() => {
                !lockedFeatures.CustomPlaidCredentialsSet
                  ? updateIsLocked(true, 'Plaid')
                  : history.push('/integrations/Plaid');
              }}
            />
            <SettingsCard
              Image="invertie"
              Title={t('inveriteConfigurationTitle')}
              isLocked={!lockedFeatures.CustomInveriteCredentialsSet}
              onClickDetails={() => {
                !lockedFeatures.CustomInveriteCredentialsSet
                  ? updateIsLocked(true, 'Inverite')
                  : history.push('/integrations/Inverite');
              }}
            />
            <SettingsCard
              Image="globalPayments"
              Title={t('globalPaymentsConfigurationTitle')}
              onClickDetails={() => {
                history.push('/integrations/global-pay');
              }}
            />
            {permissions.ViewAccountingBillsAndInvoices && (
              <SettingsCard
                Image="accountingSoftware"
                Title={t('accountingSoftwareConfigurationTitle')}
                isLocked={!lockedFeatures.AccountingSoftwareIntegrationEnabled}
                onClickDetails={() => {
                  !lockedFeatures.AccountingSoftwareIntegrationEnabled
                    ? updateIsLocked(true, 'Accounting Software')
                    : history.push('/integrations/accounting-software');
                }}
              />
            )}
          </div>
        </Box>
      </Box>
    </div>
  );
};
export default Integrations;
